var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.navSidebarClasses },
    [
      _c(
        "header",
        { staticClass: "nav-sidebar__header" },
        [
          _c("DuoToneTeamingLetterLogo", {
            attrs: { "class-name": "nav-sidebar__letter-logo" }
          }),
          _vm._v(" "),
          _c("font-awesome-icon", {
            staticClass: "nav-sidebar__close-icon",
            attrs: { icon: ["fas", "times"], size: "lg" },
            on: { click: _vm.onCloseIconClicked }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "nav",
        { class: _vm.mainClasses },
        [
          _c("hr", { staticClass: "nav-sidebar__hr" }),
          _vm._v(" "),
          _vm._l(_vm.primaryNavGroups, function(navGroup) {
            return _c("NavSidebarGroup", {
              key: navGroup.key,
              attrs: {
                "class-name": "nav-sidebar__group",
                "is-selected": navGroup.isSelected,
                scale: navGroup.scale,
                theme: navGroup.theme
              },
              on: {
                click: function($event) {
                  return _vm.$emit(
                    navGroup.emits.eventName,
                    navGroup.emits.eventArgs
                  )
                }
              },
              scopedSlots: _vm._u(
                [
                  navGroup.icon || navGroup.avatar
                    ? {
                        key: "icon",
                        fn: function() {
                          return [
                            navGroup.icon
                              ? _c("font-awesome-icon", {
                                  attrs: { icon: navGroup.icon }
                                })
                              : navGroup.avatar
                              ? _c("UserAvatarSpread", {
                                  attrs: { users: [_vm.user] }
                                })
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    : null,
                  {
                    key: "text",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n\t\t\t\t" + _vm._s(navGroup.text) + "\n\t\t\t"
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "tooltip",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n\t\t\t\t" + _vm._s(navGroup.tooltip) + "\n\t\t\t"
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "items",
                    fn: function() {
                      return [
                        _c("ShowmoreItems", {
                          scopedSlots: _vm._u(
                            [
                              navGroup.primaryItems.length
                                ? {
                                    key: "primary",
                                    fn: function() {
                                      return _vm._l(
                                        navGroup.primaryItems,
                                        function(navItem) {
                                          return _c("NavSidebarItem", {
                                            key: navItem.key,
                                            attrs: {
                                              "class-name": "nav-sidebar__item",
                                              text: navItem.text,
                                              "is-selected": navItem.isSelected
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.$emit(
                                                  navItem.emits.eventName,
                                                  navItem.emits.eventArgs
                                                )
                                              }
                                            }
                                          })
                                        }
                                      )
                                    },
                                    proxy: true
                                  }
                                : null,
                              navGroup.secondaryItems.length
                                ? {
                                    key: "secondary",
                                    fn: function() {
                                      return _vm._l(
                                        navGroup.secondaryItems,
                                        function(navItem) {
                                          return _c("NavSidebarItem", {
                                            key: navItem.key,
                                            attrs: {
                                              "class-name": "nav-sidebar__item",
                                              text: navItem.text,
                                              "is-selected": navItem.isSelected
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.$emit(
                                                  navItem.emits.eventName,
                                                  navItem.emits.eventArgs
                                                )
                                              }
                                            }
                                          })
                                        }
                                      )
                                    },
                                    proxy: true
                                  }
                                : null
                            ],
                            null,
                            true
                          )
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "footer",
        { class: _vm.footerClasses },
        [
          _c("hr", { staticClass: "nav-sidebar__hr" }),
          _vm._v(" "),
          _vm._l(_vm.secondaryNavGroups, function(navGroup) {
            return _c("NavSidebarGroup", {
              key: navGroup.key,
              attrs: {
                "class-name":
                  "nav-sidebar__group nav-sidebar__group--secondary",
                "is-selected": navGroup.isSelected,
                scale: navGroup.scale,
                theme: navGroup.theme
              },
              on: {
                click: function($event) {
                  return _vm.$emit(
                    navGroup.emits.eventName,
                    navGroup.emits.eventArgs
                  )
                }
              },
              scopedSlots: _vm._u(
                [
                  navGroup.icon || navGroup.avatar
                    ? {
                        key: "icon",
                        fn: function() {
                          return [
                            navGroup.icon
                              ? _c("font-awesome-icon", {
                                  attrs: { icon: navGroup.icon }
                                })
                              : navGroup.avatar
                              ? _c("UserAvatarSpread", {
                                  attrs: { users: [_vm.user] }
                                })
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    : null,
                  {
                    key: "text",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n\t\t\t\t" + _vm._s(navGroup.text) + "\n\t\t\t"
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "tooltip",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n\t\t\t\t" + _vm._s(navGroup.tooltip) + "\n\t\t\t"
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "items",
                    fn: function() {
                      return [
                        _c("ShowmoreItems", {
                          scopedSlots: _vm._u(
                            [
                              navGroup.primaryItems.length
                                ? {
                                    key: "primary",
                                    fn: function() {
                                      return _vm._l(
                                        navGroup.primaryItems,
                                        function(navItem) {
                                          return _c("NavSidebarItem", {
                                            key: navItem.key,
                                            attrs: {
                                              "class-name": "nav-sidebar__item",
                                              text: navItem.text,
                                              "is-selected": navItem.isSelected
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.$emit(
                                                  navItem.emits.eventName,
                                                  navItem.emits.eventArgs
                                                )
                                              }
                                            }
                                          })
                                        }
                                      )
                                    },
                                    proxy: true
                                  }
                                : null,
                              navGroup.secondaryItems.length
                                ? {
                                    key: "secondary",
                                    fn: function() {
                                      return _vm._l(
                                        navGroup.secondaryItems,
                                        function(navItem) {
                                          return _c("NavSidebarItem", {
                                            key: navItem.key,
                                            attrs: {
                                              "class-name": "nav-sidebar__item",
                                              text: navItem.text,
                                              "is-selected": navItem.isSelected
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.$emit(
                                                  navItem.emits.eventName,
                                                  navItem.emits.eventArgs
                                                )
                                              }
                                            }
                                          })
                                        }
                                      )
                                    },
                                    proxy: true
                                  }
                                : null
                            ],
                            null,
                            true
                          )
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("UserSettings", { ref: "userSettings" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d32999c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d32999c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/NavSidebar.vue
// module id = Texl
// module chunks = 5